import { render } from "./ControllerList.vue?vue&type=template&id=18210b6e&ts=true"
import script from "./ControllerList.vue?vue&type=script&lang=ts"
export * from "./ControllerList.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__